<template>
  <div id="aid-point-pop">
    <div class="img-cover">
      <img
        :src="img+'?x-oss-process=image/auto-orient,1/resize,p_10/quality,q_15'"
      />
    </div>
    <div class="desc">
      <div>{{point.id}}</div>
      <div>{{point.location}}</div>
      <div>{{point.material}}</div>
      <div>
        <span v-if="point.width > 0">{{point.width}}*{{point.height}}</span>
        <span v-else>{{point.size}}</span>
      </div>
      <div>数量 {{point.count}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: { point: Object },
  created() {
    console.log("p:", this.point);
  },
  computed: {
    img() {
      return (
        this.point.images[0].url ||
        this.point.images[0].before_image.split(",")[0]
      );
    }
  }
};
</script>
<style lang="scss" scoped>
#aid-point-pop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .img-cover {
    width: 80px;
    height: 80px;
    margin-right: 6px;
    border: 4px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .sector {
    }
  }
  .desc {
    margin-left: 6px;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>